import { Link } from "react-router-dom";

const guides = [
  {
    icon: "ri-book-open-line",
    title: "Complete Spreadsheet Guide",
    desc: "Everything you need to know about CSSBuy Spreadsheet from the ground up.",
    to: "/cssbuy-spreadsheet-guide",
  },
  {
    icon: "ri-shopping-cart-2-line",
    title: "Smart Buying Guide",
    desc: "How to navigate, compare, and make confident purchasing decisions.",
    to: "/cssbuy-spreadsheet-buying-guide",
  },
  {
    icon: "ri-ship-line",
    title: "Shipping & Logistics",
    desc: "Master shipping methods, customs, and cost optimization.",
    to: "/cssbuy-spreadsheet-shipping-guide",
  },
  {
    icon: "ri-search-eye-line",
    title: "QC & Quality Control",
    desc: "Inspect QC photos like a pro and make confident pass-or-return calls.",
    to: "/cssbuy-spreadsheet-qc-guide",
  },
  {
    icon: "ri-award-line",
    title: "Best Brands & Finds",
    desc: "Discover trending brands and hidden gems the community loves.",
    to: "/cssbuy-spreadsheet-brands",
  },
  {
    icon: "ri-shield-check-line",
    title: "Safety & Scam Prevention",
    desc: "Protect yourself with community-vetted safety best practices.",
    to: "/cssbuy-spreadsheet-safety",
  },
];

export default function ArticleCTA() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20abstract%20background%20with%20warm%20beige%20cream%20and%20subtle%20sage%20green%20accents%2C%20gentle%20gradient%20with%20delicate%20texture%2C%20clean%20modern%20aesthetic%20with%20floating%20geometric%20elements%2C%20editorial%20style%20with%20soft%20diffused%20lighting%20and%20organic%20composition%2C%20negative%20space%20for%20text%20placement&width=1800&height=800&seq=cta-bg-2026&orientation=landscape"
        alt="CSSBuy Spreadsheet guides collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/75 to-foreground-900/55" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
            Master <span className="text-primary-300">CSSBuy Spreadsheet</span> Shopping
          </h2>
          <p className="text-white/75 text-sm md:text-base max-w-lg mx-auto leading-relaxed">
            Explore our complete library of in-depth guides covering every aspect of spreadsheet shopping. Written by the community, for the community.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {guides.map((guide) => (
            <Link
              key={guide.to}
              to={guide.to}
              className="group flex items-start gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-lg p-4 border border-white/10 hover:border-white/20 transition-all duration-200 cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/15 text-white flex-shrink-0 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                <i className={`${guide.icon} text-sm`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-white mb-1 group-hover:text-primary-200 transition-colors duration-200">
                  {guide.title}
                </h3>
                <p className="text-xs text-white/60 leading-relaxed">
                  {guide.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}